exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Example Media queries\n *\n * @media (max-width: @kng-screen-xs-max) { ... }\n * @media (min-width: @kng-screen-sm-min) and (max-width: @kng-screen-sm-max) { ... }\n * @media (min-width: @kng-screen-md-min) and (max-width: @kng-screen-md-max) { ... }\n * @media (min-width: @kng-screen-lg-min) { ... }\n *\n */\n.thing-thresholds .timespan {\n  color: #253b56;\n  margin-right: 15px;\n}\n.thing-thresholds .threshold {\n  font-weight: 500;\n  color: #253b56;\n}\n.thing-thresholds .thing-thresholds-col {\n  margin-right: 50px;\n  display: inline-block;\n  vertical-align: top;\n}\n.thing-thresholds .thing-thresholds-col:last-child {\n  margin-right: 0;\n}\n.thing-opening-time {\n  margin-top: 20px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/cot-web/src/app/components/things/threshold/threshold.component.less
// module id = ../../../../../src/app/components/things/threshold/threshold.component.less
// module chunks = main